import "./landing.scss";

import { useLanding } from "./landing.hook";
import { Helmet } from "react-helmet";
import { Section7 } from "./sections/section7/section7";
import { Section6 } from "./sections/section6/section6";
import { Section5 } from "./sections/section5/section5";
import { Section4 } from "./sections/section4/section4";
import { Section3 } from "./sections/section3/section3";
import { Section2 } from "./sections/section2/section2";
import { Section1 } from "./sections/section1/section1";
import { MAX_WIDTH } from "src/config";

export const Landing = () => {
  const { t } = useLanding();

  return (
    <div className="d-flex justify-content-center">
      <div className="landing-bg" style={{ maxWidth: MAX_WIDTH }}>
        <Helmet>
          <title>{t("meta.landing.title")}</title>
          <meta name="description" content={t("meta.landing.description")} />
        </Helmet>
        <div className="landing-section1-container">
          <Section1 />
        </div>
        <div className="landing-section2-container">
          <Section2 />
        </div>
        <div>
          <Section3 />
        </div>
        <div className="landing-section4-container">
          <Section4 />
        </div>
        <div className="landing-section5-container">
          <Section5 />
        </div>
        <div className="landing-section6-container">
          <Section6 />
        </div>
        <div className="landing-section7-container">
          <Section7 />
        </div>
      </div>
    </div>
  );
};
